<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 2; backdrop-filter: blur(2px)"
      v-if="loaderStatus"
    >
      <Spinner />
    </div>
    <div class="main-container viewcand-parent">
      <div
        class="
          asc-page-heading-2
          d-flex
          align-items-center
          justify-content-between
        "
      >
        <div class="d-flex align-items-center">
          <img
            class="mr-3 pointer"
            src="@/assets/customfield/blueBackArrow.svg"
            alt=""
            @click="gobackpointer"
          />
          Candidate Profile
        </div>
      </div>
      <div class="d-flex mt-2" v-if="profile">
        <div class="cp-left-container mr-3">
          <div class="cp-biodata-cont">
            <div class="biodata-top">
              <div class="cp-profile-pic">
                <img class="w-100 h-100" :src="profile.image" alt="" />
              </div>
              <div class="w-85">
                <div class="white-bold-txt">
                  {{ profile.firstName }} {{ profile.lastName }}
                </div>
                <div class="cp-white-txt">
                  <span
                    v-if="
                      profile.designation != null &&
                      profile.designation != '' &&
                      profile.totalYearsOfExp != null
                    "
                  >
                    {{ profile.designation }} |
                    {{ profile.totalYearsOfExp }}
                    {{ profile.totalYearsOfExp > 1 ? "Years" : "Year" }}
                  </span>
                  <span
                    v-else-if="
                      profile.designation != null &&
                      profile.designation != '' &&
                      profile.totalYearsOfExp == null
                    "
                  >
                    {{ profile.designation }} |
                    {{ toTitleCase(profile.experienceLevelFormatted) }}</span
                  >
                  <span v-else-if="profile.totalYearsOfExp != null">
                    {{ toTitleCase(profile.experienceLevelFormatted) }}
                    | {{ profile.totalYearsOfExp }}
                    {{ profile.totalYearsOfExp > 1 ? "Years" : "Year" }}</span
                  >
                  <span v-else>
                    {{ toTitleCase(profile.experienceLevelFormatted) }}</span
                  >
                </div>
              </div>
              <template
                v-if="
                  $route.query.source === 'approvecandidate' &&
                  $route.query.status !== 'accepted' &&
                  $route.query.status !== 'rejected'
                "
                ><div class="d-flex pt-2">
                  <div
                    @click="
                      decision = 'reject';
                      openAcceptReject = true;
                    "
                    class="d-flex align-items-center cvs-button pointer"
                  >
                    <div class="pl-3">Reject</div>
                    <img
                      class="pl-2 pr-1"
                      src="@/assets/cvsearch/cand-approval-reject.svg"
                      alt=""
                    />
                  </div>
                  <div>
                    <img
                      class="px-1"
                      src="@/assets/cvsearch/cand-approval-line.svg"
                      alt=""
                    />
                  </div>
                  <div
                    @click="
                      decision = 'approve';
                      openAcceptReject = true;
                    "
                    class="d-flex align-items-center cvs-button pointer"
                  >
                    <div class="pl-3">Approve</div>
                    <img
                      class="pl-2 pr-1"
                      src="@/assets/cvsearch/cand-approval-approve.svg"
                      alt=""
                    />
                  </div>
                </div>
              </template>
              <template
                v-else-if="
                  $route.query.from != 'BotAnalysis' &&
                  $route.query.source !== 'approvecandidate' &&
                  $route.query.from != 'vendorkanban' &&
                  $route.query.from != 'vendortalentpool'
                "
              >
                <div v-if="$route.query.from != 'kanban'" class="d-flex pt-2">
                  <div
                    :class="atsResumeLoader ? 'disabled-text' : ''"
                    v-if="roles.includes('ADD_TO_JD')"
                    @mouseover="showAddToJobText = true"
                    @mouseleave="showAddToJobText = false"
                    class="
                      d-flex
                      align-items-center
                      position-relative
                      cvs-button-trans cvs-button
                      pointer
                    "
                    @click="!atsResumeLoader ? showJobModal() : ''"
                  >
                    <div v-if="showAddToJobText" class="pl-2 position-absolute">
                      Add to Job
                    </div>
                    <div class="cvs-svg-pos">
                      <img
                        v-if="!showAddToJobText"
                        src="@/assets/cvsearch/add-to-jobs-white.svg"
                        alt=""
                      />
                      <img
                        v-else
                        src="@/assets/cvsearch/add-to-jobs-blue.svg"
                        alt=""
                      />
                    </div>
                  </div>
                  <div
                    :class="atsResumeLoader ? 'disabled-text' : ''"
                    @mouseover="showAddToTalentPool = true"
                    @mouseleave="showAddToTalentPool = false"
                    class="
                      ml-2
                      d-flex
                      align-items-center
                      position-relative
                      cvs-button-trans-2 cvs-button
                      pointer
                    "
                    @click="!atsResumeLoader ? goToAddToTalentPool() : ''"
                  >
                    <div
                      v-if="showAddToTalentPool"
                      class="pl-2 position-absolute"
                    >
                      Add to Talentpool
                    </div>
                    <div class="cvs-svg-pos">
                      <img
                        v-if="!showAddToTalentPool"
                        src="@/assets/cvsearch/add-to-talentpool-white.svg"
                        alt=""
                      />
                      <img
                        v-else
                        src="@/assets/cvsearch/add-to-talentpool-blue.svg"
                        alt=""
                      />
                    </div>
                  </div>

                  <div
                    v-if="
                      whereFrom != 'kanban' &&
                      $route.query.from != 'BotAnalysis'
                    "
                    class="ml-2 pointer"
                    @click="bookmark(profile)"
                  >
                    <img
                      src="@/assets/cvsearch/whiteBOOK.svg"
                      alt=""
                      v-if="!profile.bookmark"
                      v-b-tooltip.hover="'Bookmark'"
                    />
                    <img
                      src="@/assets/cvsearch/blueBOOK.svg"
                      v-else
                      alt=""
                      v-b-tooltip.hover="'Remove Bookmark'"
                    />
                  </div>
                </div>
              </template>
            </div>
            <div class="biodata-bottom">
              <div class="cp-left-padding d-flex">
                <div class="d-flex align-items-center">
                  <img
                    class="mr-2"
                    src="@/assets/cvsearch/birthday.svg"
                    alt=""
                  />
                  {{ profile.dateOfBirth | formatDateToCustomString }}
                </div>
                <div class="d-flex align-items-center ml-4">
                  <img class="mr-2" src="@/assets/cvsearch/mail.svg" alt="" />
                  {{ profile.email }}
                </div>
                <div class="d-flex align-items-center ml-4">
                  <img
                    class="mr-2"
                    src="@/assets/cvsearch/lightcall.svg"
                    alt=""
                  />{{
                    arrayToString([
                      profile.phoneNumber,
                      profile.altPhoneNumber,
                    ]) || "NA"
                  }}
                </div>
                <div class="d-flex align-items-center ml-4">
                  <img
                    class="mr-2"
                    src="@/assets/cvsearch/lightlocation.svg"
                    alt=""
                  />{{
                    arrayToString([
                      profile.city,
                      profile.state,
                      profile.country,
                    ]) || "NA"
                  }}
                </div>
              </div>
              <div>
                <div class="cp-bold-black-txt mt-2">About Me</div>
                <div class="cp-grey-txt-2" v-if="profile.profileSummary">
                  {{
                    (showMore.profileSummary
                      ? profile.profileSummary
                      : profile.profileSummary.length > 250
                      ? profile.profileSummary.slice(0, 250) + "..."
                      : profile.profileSummary) || "NA"
                  }}
                  <span
                    style="color: #20639b"
                    class="pointer"
                    v-if="profile.profileSummary.length > 250"
                    @click="showMore.profileSummary = !showMore.profileSummary"
                    >show {{ showMore.profileSummary ? "less" : "more" }}</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="profile.jobPreferenceSubmit"
            class="candash-tabs-newcard mt-2"
          >
            <div class="cp-grey-txt">Job Preferences</div>
            <div class="demograpgic-data"></div>
            <b-row>
              <b-col cols="3">
                <div class="cp-blue-reg-txt mt-3">Notice Period</div>
                <div class="cp-grey-reg-txt mt-1">
                  {{ profile.noticePeriod || "NA" }}
                </div>
              </b-col>
              <b-col cols="3">
                <div class="cp-blue-reg-txt mt-3">Current CTC</div>
                <div class="cp-grey-reg-txt mt-1">
                  {{ profile.currentCTC ? profile.currentCTC + " LPA" : "NA" }}
                </div>
              </b-col>
              <b-col cols="3">
                <div class="cp-blue-reg-txt mt-3">Expected CTC</div>
                <div class="cp-grey-reg-txt mt-1">
                  {{
                    profile.expectedCTC ? profile.expectedCTC + " LPA" : "NA"
                  }}
                </div>
              </b-col>
              <b-col cols="3">
                <div class="cp-blue-reg-txt mt-3">Preferred Location</div>
                <div class="cp-grey-reg-txt mt-1">
                  {{ arrayToString(profile.willingToRelocateTo) || "NA" }}
                </div>
              </b-col>
              <b-col cols="3">
                <div class="cp-blue-reg-txt mt-3">Work Type</div>
                <div class="cp-grey-reg-txt mt-1">
                  {{ arrayToString(profile.workType) || "NA" }}
                </div>
              </b-col>
              <b-col cols="3">
                <div class="cp-blue-reg-txt mt-3">Languages Known</div>
                <div class="cp-grey-reg-txt mt-1">
                  {{ arrayToString(profile.languages) || "NA" }}
                </div>
              </b-col>
            </b-row>
          </div>
          <div
            class="candash-tabs-newcard mt-2"
            v-if="profile.educationalInfo.length"
          >
            <div class="cp-grey-txt">Education</div>

            <div class="demograpgic-data mb-3"></div>
            <div
              v-for="(education, i) in profile.educationalInfo"
              :key="i"
              class="cp-blue-cards mb-2"
            >
              <div><img src="@/assets/cvsearch/eduDP.svg" alt="" /></div>
              <div class="ml-3 w-93">
                <div class="cp-blue-reg-txt-2">
                  {{ toTitleCase(education.institute) || "NA" }}
                </div>
                <div class="d-flex align-items-center cp-grey-reg-txt-2 mt-1">
                  <div class="max-w45 text-truncate">
                    {{ toTitleCase(education.qualification) }}
                  </div>
                  <div
                    class="candash-dot ml-2 mr-2"
                    v-if="education.degree"
                  ></div>
                  <div class="max-w45 text-truncate">
                    {{ education.degree }} ({{
                      education.courseDuration === 1
                        ? "1 Year"
                        : education.courseDuration + " Years"
                    }})
                  </div>
                  <div
                    class="candash-dot ml-2 mr-2"
                    v-if="education.gradePercentage"
                  ></div>
                  <div>{{ education.gradePercentage }}%</div>
                </div>
                <div class="d-flex align-items-center cp-light-grey-txt mt-1">
                  <div class="max-w45 text-truncate">
                    {{ formatDate(education.yearOfJoining) }} -
                    {{
                      education.currentEducation
                        ? "Present"
                        : formatDate(education.yearOfPassout)
                    }}
                  </div>
                  <div class="ml-2 mr-2">|</div>
                  <div>
                    {{ education.location || "NA" }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="candash-tabs-newcard mt-2"
            v-if="profile.experience.length"
          >
            <div class="cp-grey-txt">Experience</div>

            <div class="demograpgic-data mb-3"></div>
            <div
              v-for="(experience, i) in profile.experience"
              :key="i"
              class="cp-blue-cards mb-2"
            >
              <div><img src="@/assets/cvsearch/expDP.svg" alt="" /></div>
              <div class="ml-3 w-93">
                <div class="cp-blue-reg-txt-2">
                  {{ toTitleCase(experience.designation) || "NA" }}
                </div>
                <div class="d-flex align-items-center cp-grey-reg-txt-2 mt-1">
                  <div>
                    {{ toTitleCase(experience.companyName) || "NA" }}
                  </div>
                  <div class="candash-dot ml-2 mr-2"></div>
                  <div class="max-w45 text-truncate">
                    {{ toTitleCase(experience.jobType) || "NA" }}
                  </div>
                </div>
                <div class="d-flex align-items-center cp-light-grey-txt mt-1">
                  <div class="max-w45 text-truncate">
                    {{ formatDate(experience.startDate) }} -
                    {{
                      experience.currentExperience
                        ? "Present"
                        : formatDate(experience.endDate)
                    }}
                  </div>
                  <div class="ml-2 mr-2">|</div>
                  <div>
                    {{ experience.location || "NA" }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="candash-tabs-newcard mt-2"
            v-if="profile.skills.length || profile.interpersonalSkills.length"
          >
            <div class="cp-grey-txt">Skills</div>

            <div class="demograpgic-data mb-3"></div>
            <div class="cp-black-txt mb-2" profile.skills.length>
              Technical Skills
            </div>
            <div
              v-for="(skill, i) in profile.skills"
              :key="i + skill.skillName"
              class="cp-blue-cards mb-2"
            >
              <div><img src="@/assets/cvsearch/skillDP.svg" alt="" /></div>
              <div class="ml-3 w-93">
                <div class="cp-blue-reg-txt-2">
                  {{ toTitleCase(skill.skillName) }}
                </div>
                <div class="d-flex align-items-center mt-1">
                  <div class="cp-grey-reg-txt mr-5" v-if="skill.yearsOfExp">
                    {{
                      skill.yearsOfExp === 1
                        ? "1 Year"
                        : skill.yearsOfExp + " Years"
                    }}
                  </div>
                  <div class="cp-skill-tag">
                    {{ toTitleCase(skill.expertiseLevel) }}
                  </div>
                </div>
              </div>
            </div>
            <div
              class="cp-black-txt mb-2 mt-4"
              v-if="profile.interpersonalSkills.length"
            >
              Interpersonal Skills
            </div>
            <div
              v-for="(skill, i) in profile.interpersonalSkills"
              :key="i + skill.skillName"
              class="cp-blue-cards mb-2"
            >
              <div><img src="@/assets/cvsearch/skillDP.svg" alt="" /></div>
              <div class="ml-3 w-93">
                <div class="cp-blue-reg-txt-2">
                  {{ toTitleCase(skill.skillName) }}
                </div>
                <div class="cp-skill-tag mt-2">
                  {{ toTitleCase(skill.expertiseLevel) }}
                </div>
              </div>
            </div>
          </div>
          <div class="candash-tabs-newcard mt-2" v-if="profile.projects.length">
            <div class="cp-grey-txt">Project</div>

            <div class="demograpgic-data mb-3"></div>
            <div
              class="cp-blue-cards flex-column mb-2"
              :key="i"
              v-for="(project, i) in profile.projects"
            >
              <div class="d-flex align-items-start">
                <div><img src="@/assets/cvsearch/proDP.svg" alt="" /></div>
                <div class="ml-3">
                  <div class="cp-blue-reg-txt-2">
                    {{ project.title }}
                  </div>

                  <div class="max-w45 text-truncate cp-light-grey-txt mt-1">
                    {{ formatDate(project.startDate) }} -
                    {{
                      project.endDate ? formatDate(project.endDate) : "Present"
                    }}
                  </div>
                </div>
              </div>
              <b-row class="w-100 mt-3">
                <b-col cols="4">
                  <div class="cp-grey-reg-txt">Project Role</div>
                  <div class="cp-grey-reg-txt-3 mt-1">
                    {{ toTitleCase(project.role) || "NA" }}
                  </div>
                </b-col>
                <b-col cols="3">
                  <div class="cp-grey-reg-txt">Domain</div>
                  <div class="cp-grey-reg-txt-3 mt-1">
                    {{ toTitleCase(project.domain) || "NA" }}
                  </div>
                </b-col>
                <b-col cols="5">
                  <div class="cp-grey-reg-txt">Skills Used</div>
                  <div class="d-flex flex-wrap mt-1">
                    <div
                      v-for="(skill, i) in project.skillsUsed"
                      :key="i"
                      class="cp-tag-skill-used mr-2"
                    >
                      {{ toTitleCase(skill) }}
                    </div>
                  </div>
                </b-col>
              </b-row>
              <div class="cp-grey-reg-txt mt-3">Description</div>
              <div class="cp-grey-reg-txt-4 mt-1 pr-5 text-break">
                {{ project.summary || "NA" }}
              </div>
              <div class="cp-grey-reg-txt mt-4">Responsibilities</div>
              <div class="cp-grey-reg-txt-4 text-break mt-1">
                <template v-if="project.responsibility">
                  <ul class="candash-dotted-list">
                    <li
                      v-for="(responsibility, i) in conditionallySlice(
                        project.responsibility,
                        !showMore.project.responsibility[i],
                        2
                      )"
                      :key="i"
                    >
                      {{ responsibility }}
                    </li>
                  </ul>
                </template>
                <template v-else>NA</template>
              </div>
              <span
                class="cp-blue-reg-txt-2 pointer"
                v-if="project.responsibility.length > 2"
                @click="
                  toggleShowMoreForIndex(showMore.project.responsibility, i)
                "
                >show
                {{ showMore.project.responsibility[i] ? "less" : "more" }}</span
              >
            </div>
          </div>
          <div
            class="candash-tabs-newcard mt-2"
            v-if="
              profile.awards.length ||
              profile.events.length ||
              certificates.length
            "
          >
            <div class="cp-grey-txt">Achievement</div>

            <div class="demograpgic-data mb-3"></div>
            <div class="cp-black-txt mb-2" v-if="profile.awards.length">
              Awards
            </div>
            <div
              v-for="(award, i) in profile.awards"
              :key="i + award.title"
              class="cp-blue-cards mb-2"
            >
              <div><img src="@/assets/cvsearch/skillDP.svg" alt="" /></div>
              <div class="ml-3 w-93">
                <div class="cp-blue-reg-txt-2">
                  {{ toTitleCase(award.title) || "NA" }}
                  <img
                    @click="openLink(award.link)"
                    class="ml-3 pointer"
                    src="@/assets/cvsearch/link.svg"
                    alt=""
                    v-if="award.link != null"
                  />
                </div>

                <div class="cp-grey-reg-txt mr-5">
                  {{ award.issuingOrganization || "NA" }}
                </div>
              </div>
            </div>
            <div class="cp-black-txt mb-2 mt-4" v-if="certificates.length">
              Certificates
            </div>
            <div
              v-for="(certificate, i) in certificates"
              :key="i + certificate.title"
              class="cp-blue-cards flex-column mb-2"
            >
              <div class="d-flex align-items-start">
                <div>
                  <img src="@/assets/cvsearch/skillDP.svg" alt="" />
                </div>
                <div class="ml-3 w-93">
                  <div class="cp-blue-reg-txt-2">
                    {{ toTitleCase(certificate.title) || "NA" }}
                  </div>
                  <div class="cp-grey-reg-txt mr-5 mt-1">
                    {{ toTitleCase(certificate.issuingOrganization) || "NA" }}
                  </div>
                </div>
              </div>
              <b-row class="w-100 mt-4">
                <b-col cols="6">
                  <div class="cp-grey-reg-txt">Issued Organization</div>
                  <div class="cp-grey-reg-txt-3 mt-1">
                    {{ toTitleCase(certificate.issuingOrganization) || "NA" }}
                  </div>
                </b-col>
                <b-col cols="3">
                  <div class="cp-grey-reg-txt">Issued Date</div>
                  <div class="cp-grey-reg-txt-3 mt-1">
                    {{
                      certificate.issueDate.split("-").reverse().join("-") ||
                      "NA"
                    }}
                  </div>
                </b-col>
                <b-col cols="3">
                  <div class="cp-grey-reg-txt">Certification ID</div>
                  <div class="cp-grey-reg-txt-3 mt-1">
                    {{
                      certificate.certificateID
                        ? certificate.certificateID
                        : "NA"
                    }}
                  </div>
                </b-col>
              </b-row>
              <div class="cp-grey-reg-txt mt-4" v-if="certificate.description">
                Description
              </div>
              <div
                class="cp-grey-reg-txt-3 mt-1 pr-5"
                v-if="certificate.description"
              >
                {{
                  (certificate.description.length > 250
                    ? certificate.description.slice(0, 250) + "..."
                    : certificate.description) || "NA"
                }}
                <span
                  style="color: #20639b"
                  v-if="certificate.description.length > 250"
                  >show more</span
                >
              </div>
            </div>
            <div class="cp-black-txt mb-2 mt-4" v-if="profile.events.length">
              Events
            </div>
            <div
              v-for="(event, i) in profile.events"
              :key="i + event.title"
              class="cp-blue-cards mb-2"
            >
              <div><img src="@/assets/cvsearch/skillDP.svg" alt="" /></div>
              <div class="ml-3 w-80">
                <div class="cp-blue-reg-txt-2">
                  {{ toTitleCase(event.title) || "NA" }}
                </div>

                <div class="cp-grey-reg-txt mr-5">
                  {{ event.issuingOrganization || "NA" }}
                </div>
              </div>
              <div class="w-20 cv-font-size-13">
                <div class="cp-grey-reg-txt">Date</div>
                <div class="cp-grey-reg-txt-3">
                  {{ event.issueDate.split("-").reverse().join("-") || "NA" }}
                </div>
              </div>
            </div>
          </div>

          <div
            class="candash-tabs-newcard mt-2"
            v-if="profile.portfolio.length || profile.hobbies.length"
          >
            <div class="cp-grey-txt">Portfolio</div>

            <div class="demograpgic-data mb-3"></div>
            <div class="cp-black-txt mb-2" v-if="profile.portfolio.length">
              Portfolio Websites
            </div>
            <div
              v-for="(portfolio, i) in profile.portfolio"
              :key="i + portfolio.portfolioName"
              class="cp-blue-cards mb-2"
            >
              <div><img src="@/assets/cvsearch/skillDP.svg" alt="" /></div>
              <div class="ml-3 w-93">
                <div class="cp-blue-reg-txt-2">
                  {{ toTitleCase(portfolio.portfolioName) }}
                </div>
                <div class="cp-blue-reg-txt-3 mt-1">
                  <a :href="portfolio.portfolioLink">{{
                    portfolio.portfolioLink
                  }}</a>
                </div>
              </div>
            </div>
            <div class="cp-black-txt mb-2 mt-4" v-if="profile.hobbies.length">
              Interests / Hobbies
            </div>
            <div
              v-for="(hobby, i) in profile.hobbies"
              :key="i + hobby"
              class="cp-blue-cards align-items-center mb-2"
            >
              <div><img src="@/assets/cvsearch/skillDP.svg" alt="" /></div>
              <div class="ml-3 w-93">
                <div class="cp-blue-reg-txt-2">
                  {{ toTitleCase(hobby) }}
                </div>
              </div>
            </div>
          </div>
          <div
            class="candash-tabs-newcard p-0 mt-2"
            v-if="ATSResumeExists || videoResumeExists"
          >
            <div class="cp-header">
              <!-- <div
                @click="showResume = GRAPHICAL"
                v-if="graphicalResumeExists"
                :class="showGraphicalResume ? 'cp-tab-sel' : 'cp-tab-nonsel'"
              >
                Graphical Resume
                <div v-if="showGraphicalResume" class="cp-sel-bar"></div>
              </div> -->
              <div
                @click="showResume = ATS"
                v-if="ATSResumeExists"
                :class="showATSResume ? 'cp-tab-sel' : 'cp-tab-nonsel'"
              >
                ATS Resume

                <div v-if="showATSResume" class="cp-sel-bar"></div>
              </div>
              <div
                @click="showResume = VIDEO"
                v-if="videoResumeExists"
                :class="showVideoResume ? 'cp-tab-sel' : 'cp-tab-nonsel'"
              >
                Video Snapshot

                <div v-if="showVideoResume" class="cp-sel-bar"></div>
              </div>
            </div>
            <div class="cp-resume-container" id="resume-container">
              <!-- GRAPHICAL RESUME -->
              <div
                v-if="showGraphicalResume"
                @mouseenter="showExpandButton = true"
                @mouseleave="showExpandButton = false"
                class="graph-cont position-relative"
              >
                <b-overlay
                  :show="Object.keys(graphicalResume).length === 0"
                  rounded="sm"
                  class="h-100 w-100"
                >
                  <template v-if="graphicalResume.isColumned">
                    <div
                      id="graph-resume"
                      class="
                        a4
                        template-div
                        position-relative
                        d-flex
                        align-items-center
                        justify-content-center
                      "
                      :class="{
                        'haze-hover': showExpandButton && isTemplateLoaded,
                      }"
                    >
                      <div class="h-100 w-100 d-flex">
                        <div class="h-100" style="width: 33.3%">
                          <div
                            v-html="graphicalResume.columnData[0].data"
                            class="w-100 h-75"
                          ></div>
                          <div
                            v-html="graphicalResume.columnData[1].data"
                            class="w-100 h-25"
                          ></div>
                        </div>

                        <div style="width: 66.6%" class="h-100">
                          <div
                            class="d-flex w-100"
                            v-for="(row, index) in graphicalResume.rows"
                            :key="index"
                            :style="applyMargin(index)"
                          >
                            <div
                              style="margin-left: 3px"
                              :style="
                                index1 > 0
                                  ? `width: ${svgData.width}%;`
                                  : `width: ${svgData.width}%;`
                              "
                              v-for="(svgData, index1) in graphicalResume
                                .rowData[row]"
                              :key="index1"
                              v-html="svgData.data"
                            ></div>
                            <template
                              v-if="
                                graphicalResume.sharedRow && row === 'row_1'
                              "
                            >
                              <div class="w-50">
                                <div
                                  class="h-50 w-100"
                                  v-for="(
                                    svgData, index2
                                  ) in graphicalResume.sharedRowData"
                                  :key="index2"
                                  v-html="svgData.data"
                                  style="margin-left: 2px"
                                  :style="
                                    index2 > 0
                                      ? 'margin-top: 1px;'
                                      : 'margin-top: 0px;'
                                  "
                                ></div>
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="showExpandButton && isTemplateLoaded"
                        class="position-absolute expand-pos"
                        expand-resume-btn
                      >
                        <img
                          class="pointer"
                          @click="isResumeExpanded = true"
                          src="@/assets/cvsearch/showResume.svg"
                          alt=""
                        />
                      </div>
                    </div>
                  </template>

                  <template v-else>
                    <!-- use this class when update button comes 'haze-update' -->
                    <div
                      id="graph-resume"
                      class="
                        a4
                        template-div
                        position-relative
                        d-flex
                        align-items-center
                        justify-content-center
                      "
                      :class="{
                        'haze-hover': showExpandButton && isTemplateLoaded,
                      }"
                    >
                      <div class="w-100 h-100">
                        <div
                          class="d-flex w-100"
                          v-for="(row, index) in graphicalResume.rows"
                          :key="index"
                          :style="applyStyle(index)"
                        >
                          <div
                            :style="
                              index1 > 0
                                ? `margin-left:6px;width: ${svgData.width}%;`
                                : `margin-left:0px;width: ${svgData.width}%;`
                            "
                            v-for="(svgData, index1) in graphicalResume.rowData[
                              row
                            ]"
                            :key="index1"
                            v-html="svgData.data"
                          ></div>
                        </div>
                      </div>
                      <div
                        v-if="showExpandButton && isTemplateLoaded"
                        class="position-absolute expand-pos"
                        expand-resume-btn
                      >
                        <img
                          class="pointer"
                          @click="isResumeExpanded = true"
                          src="@/assets/cvsearch/showResume.svg"
                          alt=""
                        />
                      </div>
                    </div>
                  </template>
                </b-overlay>
              </div>
              <div
                v-else-if="showATSResume"
                class="
                  d-flex
                  align-items-center
                  justify-content-center
                  h-91
                  w-100
                "
              >
                <img
                  class="mr-5 pointer"
                  src="@/assets/cvsearch/pageLeft.svg"
                  alt=""
                  v-if="atsPagination.currentPage > 1"
                  @click="atsPagination.currentPage -= 2"
                />
                <img
                  class="mr-5"
                  src="@/assets/cvsearch/pageLeftDis.svg"
                  alt=""
                  v-else
                />
                <b-overlay
                  :show="!isATSTemplateLoaded"
                  class="
                    position-relative
                    ats-cont
                    d-flex
                    justify-content-center
                  "
                >
                  <div
                    class="d-flex h-100"
                    @mouseenter="showExpandButton = true"
                    @mouseleave="showExpandButton = false"
                    :class="[
                      showExpandButton
                        ? atsPagination.currentPage + 1 <=
                          atsPagination.totalPages
                          ? 'haze-hover'
                          : 'haze-hover-2'
                        : '',
                      atsPagination.currentPage + 1 <= atsPagination.totalPages
                        ? 'w-100 justify-content-between'
                        : 'w-50 justify-content-center',
                    ]"
                  >
                    <div
                      v-if="showExpandButton"
                      :class="
                        atsPagination.currentPage + 1 <=
                        atsPagination.totalPages
                          ? 'expand-pos'
                          : 'expand-pos-2'
                      "
                    >
                      <img
                        src="@/assets/cvsearch/showResume.svg"
                        alt=""
                        @click="
                          (atsModalPagination.currentPage = 1),
                            (isResumeExpanded = true)
                        "
                      />
                    </div>
                    <div
                      :class="
                        atsPagination.currentPage + 1 <=
                        atsPagination.totalPages
                          ? 'ats-sub-cont'
                          : 'ats-sub-cont-2'
                      "
                    >
                      <img
                        class="h-100 w-100"
                        :src="
                          atsResume.resumeDataUrls &&
                          atsResume.resumeDataUrls[
                            atsPagination.currentPage - 1
                          ]
                        "
                        alt=""
                      />
                    </div>
                    <div
                      class="ats-sub-cont"
                      v-if="
                        atsPagination.currentPage + 1 <=
                        atsPagination.totalPages
                      "
                    >
                      <img
                        class="h-100 w-100"
                        :src="
                          atsResume.resumeDataUrls[atsPagination.currentPage]
                        "
                        alt=""
                      />
                    </div>
                  </div>
                </b-overlay>
                <img
                  class="ml-5 pointer"
                  src="@/assets/cvsearch/pageRight.svg"
                  alt=""
                  v-if="
                    atsPagination.currentPage + 1 < atsPagination.totalPages
                  "
                  @click="atsPagination.currentPage += 2"
                />
                <img
                  class="ml-5"
                  src="@/assets/cvsearch/pageRightDis.svg"
                  alt=""
                  v-else
                />
              </div>
              <div
                v-else-if="showVideoResume"
                class="d-flex flex-column align-items-center h-100 w-100"
              >
                <div
                  class="
                    cp-black-txt-4
                    d-flex
                    justify-content-start
                    w-100
                    pl-4
                    mt-3
                  "
                >
                  Preview Video Snapshot
                </div>
                <div class="cp-video-resume-cont mt-3">
                  <div class="cp-vr-text p-2 pl-3">
                    {{
                      profile.videoResume
                        .split("/")
                        .slice(-1)[0]
                        .split("?")
                        .slice(-2, -1)[0]
                    }}
                  </div>
                  <div class="video-container">
                    <video
                      oncontextmenu="return false"
                      controlsList="nodownload"
                      :src="profile.videoResume"
                      :isMuted="false"
                      :autoplay="false"
                      :controls="true"
                      :loop="false"
                      width="100%"
                      height="100%"
                      style="
                        object-fit: unset;
                        height: 100%;
                        border-radius: 5px;
                      "
                    ></video>
                  </div>
                </div>
              </div>
              <div
                class="d-flex align-items-center download-resume pointer mt-3"
                @click="downloadResume"
                v-if="!showVideoResume"
                :class="{
                  'disabled-text':
                    isDownloading ||
                    (showGraphicalResume && !isTemplateLoaded) ||
                    (showATSResume && !isATSTemplateLoaded),
                }"
              >
                <img
                  v-if="isDownloading"
                  id="rotatingDiv"
                  class="rotate mr-2"
                  src="@/assets/cvsearch/loader.svg"
                  alt=""
                />
                <img
                  v-else
                  src="@/assets/cvsearch/blueDownload.svg"
                  alt=""
                  class="mr-2"
                />
                {{ isDownloading ? "Downloading" : "Download" }} Resume
              </div>
            </div>
          </div>
        </div>
        <div class="cp-right-container">
          <div class="cp-top-test-card m-1">
            <div class="p-2 pl-3 border-bottom cp-bold-blue">Tests</div>

            <!-- WHEN NO TEST -->

            <div class="cp-bottom-test-card overflow-hidden">
              <div
                v-if="tests.length === 0"
                class="
                  d-flex
                  flex-column
                  align-items-center
                  justify-content-center
                  cp-notest-txt
                  h-100
                "
              >
                <img src="@/assets/cvsearch/noTest.svg" alt="" />
                No tests have been taken up by the candidate.
              </div>
              <template v-else>
                <div
                  v-for="(test, i) in tests.slice(0, 2)"
                  :key="i"
                  class="border-top p-2"
                >
                  <div
                    class="
                      d-flex
                      align-items-start
                      justify-content-between
                      pl-2
                    "
                  >
                    <div class="w-75">
                      <div class="cp-black-txt-2 text-truncate">
                        {{ test.testName }}
                      </div>
                      <div class="cp-black-txt-3 text-truncate">
                        {{ test.topicName }}
                      </div>
                    </div>
                    <div class="cp-date-txt">
                      Date : {{ test.lastAttemptedDate | formatDate }}
                    </div>
                  </div>
                  <div class="px-3 py-4 mt-2 w-100">
                    <div
                      class="
                        testrankingbar
                        d-flex
                        align-items-center
                        justify-content-between
                        position-relative
                      "
                    >
                      <div class="text-pos d-flex align-items-start">
                        <div class="d-flex align-items-center">
                          <span class="cp-datetext"> Min.&nbsp;Marks: </span>
                          &nbsp;
                          <span class="cp-asmnttext"> 0 </span>
                        </div>
                      </div>

                      <div
                        class="average-negative align-items-center"
                        :style="[
                          test.MinMax.avg == 0 ? 'left: 0px' : '',
                          test.MinMax.avg && test.MinMax.avg == test.MinMax.max
                            ? { right: 0 }
                            : test.MinMax.avg < 0
                            ? 'left:0px'
                            : test.MinMax.avg > test.MinMax.max
                            ? 'righ:0px'
                            : {
                                left:
                                  (test.MinMax.avg / test.MinMax.max) * 100 +
                                  '%',
                              },
                        ]"
                      >
                        <div class="avg-marks" :style="avgStyle(test.MinMax)">
                          <span class="cp-datetext">Avg.&nbsp;Marks:</span>
                          &nbsp;
                          <span class="cp-asmnttext">
                            {{ test.MinMax.avg }}
                          </span>
                        </div>
                      </div>
                      <div class="text-pos d-flex align-items-end">
                        <div class="d-flex align-items-center">
                          <span class="cp-datetext"> Max.&nbsp;Marks: </span>
                          &nbsp;
                          <span class="cp-asmnttext">
                            {{ test.MinMax.max }}
                          </span>
                        </div>
                      </div>

                      <div
                        v-for="(summaryItem, k) in test.summary"
                        :key="`normal-${i}-${k}`"
                        :id="`circle-normal-${i}-${k}`"
                        class="
                          d-flex
                          align-items-center
                          justify-content-center
                          pointer
                        "
                        :class="[
                          summaryItem.result === 'Pass'
                            ? 'positive-circle'
                            : 'negative-circle',
                        ]"
                        :style="[
                          summaryItem.marks < 0
                            ? { display: 'none !important' }
                            : '',
                          summaryItem.marks >= test.MinMax.max
                            ? { right: 0 }
                            : {
                                left:
                                  (summaryItem.marks / test.MinMax.max) * 100 +
                                  '%',
                              },
                          summaryItem.marks == 0 ? { left: 0 } : '',
                          { zIndex: summaryItem.marks },
                        ]"
                      >
                        <span class="cp-asmnttext-new">{{
                          summaryItem.marks
                        }}</span>

                        <b-popover
                          :target="`circle-normal-${i}-${k}`"
                          triggers="hover"
                          placement="top"
                        >
                          <div>
                            <template v-if="summaryItem.companyName != null">
                              Company Name : {{ summaryItem.companyName }}
                            </template>
                            <template v-else>
                              Organiser : {{ summaryItem.organiser }}
                            </template>
                          </div>
                          <div>
                            Passing %:
                            {{ summaryItem.passingPercentage }}
                          </div>
                        </b-popover>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div class="text-center cp-view-more p-2" v-if="tests.length > 2">
              <span v-b-modal.tests-modal class="pointer">View More...</span>
            </div>
          </div>
          <div
            class="cp-top-test-card m-1 mt-2"
            v-if="videoResumeExists || graphicalResumeExists || ATSResumeExists"
          >
            <div
              class="
                p-2
                pl-3
                pr-3
                border-bottom
                cp-bold-blue
                d-flex
                justify-content-between
              "
            >
              <div>
                {{
                  videoResumeExists
                    ? "Video Resume"
                    : graphicalResumeExists
                    ? "Graphical Resume"
                    : "ATS Resume"
                }}
              </div>
            </div>
            <!-- VIDEO RESUME -->

            <!-- <div class="cp-bottom-resume-card d-flex flex-column align-items-center">
              <div class="cp-video-resume "></div>
              <button class="viewResumeBtn mb-3">
                <img class="mr-2" src="@/assets/cvsearch/viewvideo.svg" alt="">View my video snapshot
              </button>
            </div> -->

            <div
              class="
                cp-bottom-resume-card
                d-flex
                flex-column
                justify-content-between
              "
            >
              <div class="w-100 cp-light-grey-txt-2 p-2">
                <div class="pl-2" style="width: 70%">
                  Unlock candidate potential in 30 seconds with Hire3x
                  {{
                    videoResumeExists
                      ? "Video"
                      : graphicalResumeExists
                      ? "Graphical"
                      : "ATS"
                  }}
                  Resumes.
                </div>
              </div>
              <div class="d-flex justify-content-end position-relative w-100">
                <img src="@/assets/cvsearch/resumeBack.svg" alt="" />
                <div
                  class="
                    position-absolute
                    d-flex
                    align-items-center
                    justify-content-center
                    w-100
                  "
                  style="bottom: 23px"
                >
                  <button class="viewResumeBtn" @click="scrollToResume()">
                    <img
                      v-if="videoResumeExists"
                      class="mr-2"
                      src="@/assets/cvsearch/viewvideo.svg"
                      alt=""
                    />
                    <img
                      v-else
                      class="mr-2"
                      src="@/assets/cvsearch/viewResume.svg"
                      alt=""
                    />
                    View
                    {{
                      videoResumeExists
                        ? "Video Snapshot"
                        : graphicalResumeExists
                        ? "Graphical Resume"
                        : "ATS Resume"
                    }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      :visible="isResumeExpanded"
      id="ats-resume-modal"
      centered
      hide-footer
      hide-header
      size="lg"
      no-close-on-esc
      no-close-on-backdrop
      @hidden="isResumeExpanded = false"
    >
      <div class="d-flex">
        <div class="cs-left-modal-back"></div>
        <div class="w-94">
          <div class="cs-modal-header">
            <div>Preview {{ showATSResume ? "ATS" : "Graphical" }} Resume</div>

            <div>
              <img
                class="rotate-on-hover"
                src="@/assets/img/accessconnew/blueCross.svg"
                alt=""
                @click="isResumeExpanded = false"
              />
            </div>
          </div>
          <div
            class="d-flex flex-column align-items-center pt-2 pl-4 pr-4 pb-2"
          >
            <div
              id="scrollToTop"
              class="graph-overflow p-2"
              v-if="isResumeExpanded"
            >
              <div class="Graph-modal-resume" v-if="showATSResume">
                <img
                  class="h-100 w-100"
                  :src="
                    atsResume.resumeDataUrls &&
                    atsResume.resumeDataUrls[atsModalPagination.currentPage - 1]
                  "
                  alt=""
                />
              </div>
              <div
                class="Graph-modal-resume"
                v-else-if="showGraphicalResume"
                v-html="getHTMLFile(true)"
              ></div>
            </div>
            <div
              class="
                acs-paginaTion-modal
                align-items-center
                justify-content-center
                d-flex
                w-100
              "
              v-if="showATSResume"
            >
              <b-pagination
                :per-page="1"
                align="center"
                first-number
                last-number
                @change="scrollTop()"
                :total-rows="atsModalPagination.totalPages"
                v-model="atsModalPagination.currentPage"
              >
              </b-pagination>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="tests-modal"
      centered
      hide-footer
      hide-header
      size="lg"
      @hidden="$bvModal.hide('tests-modal')"
    >
      <div>
        <div class="cs-modal-header">
          <div>Tests</div>

          <div>
            <img
              class="rotate-on-hover"
              src="@/assets/img/accessconnew/blueCross.svg"
              alt=""
              @click="$bvModal.hide('tests-modal')"
            />
          </div>
        </div>
        <div class="cs-modal-body-2">
          <div
            v-for="(test, i) in tests"
            :key="i"
            class="p-2"
            :class="i !== 0 ? 'border-top' : ''"
          >
            <div class="d-flex align-items-start justify-content-between">
              <div class="w-75">
                <div class="cp-black-txt-2 text-truncate">
                  {{ test.testName }}
                </div>
                <div class="cp-black-txt-3 text-truncate">
                  {{ test.topicName }}
                </div>
              </div>
              <div class="cp-date-txt">
                Date : {{ test.lastAttemptedDate | formatDate }}
              </div>
            </div>
            <div class="px-3 py-4 mt-2">
              <div
                class="
                  testrankingbar
                  d-flex
                  align-items-center
                  justify-content-between
                  position-relative
                "
              >
                <div class="text-pos d-flex align-items-start">
                  <div class="d-flex align-items-center">
                    <span class="cp-datetext"> Min.&nbsp;Marks: </span>
                    &nbsp;
                    <span class="cp-asmnttext"> 0 </span>
                  </div>
                </div>

                <div
                  class="average-negative align-items-center"
                  :style="[
                    test.MinMax.avg == 0 ? 'left: 0px' : '',
                    test.MinMax.avg && test.MinMax.avg == test.MinMax.max
                      ? { right: 0 }
                      : test.MinMax.avg < 0
                      ? 'left:0px'
                      : test.MinMax.avg > test.MinMax.max
                      ? 'righ:0px'
                      : {
                          left: (test.MinMax.avg / test.MinMax.max) * 100 + '%',
                        },
                  ]"
                >
                  <div class="avg-marks" :style="avgStyle(test.MinMax)">
                    <span class="cp-datetext">Avg.&nbsp;Marks:</span> &nbsp;
                    <span class="cp-asmnttext">
                      {{ test.MinMax.avg }}
                    </span>
                  </div>
                </div>
                <div class="text-pos d-flex align-items-end">
                  <div class="d-flex align-items-center">
                    <span class="cp-datetext"> Max.&nbsp;Marks: </span>
                    &nbsp;
                    <span class="cp-asmnttext">
                      {{ test.MinMax.max }}
                    </span>
                  </div>
                </div>

                <div
                  v-for="(summaryItem, k) in test.summary"
                  :key="`modal-${i}-${k}`"
                  :id="`circle-modal-${i}-${k}`"
                  class="
                    d-flex
                    align-items-center
                    justify-content-center
                    pointer
                  "
                  :class="[
                    summaryItem.result === 'Pass'
                      ? 'positive-circle'
                      : 'negative-circle',
                  ]"
                  :style="[
                    summaryItem.marks < 0 ? { display: 'none !important' } : '',
                    summaryItem.marks >= test.MinMax.max
                      ? { right: 0 }
                      : {
                          left:
                            (summaryItem.marks / test.MinMax.max) * 100 + '%',
                        },
                    summaryItem.marks == 0 ? { left: 0 } : '',
                    { zIndex: summaryItem.marks },
                  ]"
                >
                  <span class="cp-asmnttext-new">{{ summaryItem.marks }}</span>

                  <b-popover
                    :target="`circle-modal-${i}-${k}`"
                    triggers="hover"
                    placement="top"
                  >
                    <div>
                      <template v-if="summaryItem.companyName != null">
                        Company Name : {{ summaryItem.companyName }}
                      </template>
                      <template v-else>
                        Organiser : {{ summaryItem.organiser }}
                      </template>
                    </div>
                    <div>
                      Passing %:
                      {{ summaryItem.passingPercentage }}
                    </div>
                  </b-popover>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end bluebtn p-3 border-top">
          <b-button
            @click="$bvModal.hide('tests-modal')"
            class="acs-cancelBtn-modal"
            >Close</b-button
          >
        </div>
      </div>
    </b-modal>
    <AddtoJDModal
      v-if="showAddToJd"
      :showModal="showAddToJd"
      :candidateSelectedToThirdParty="populatedCustomFields"
      @close-modal="showAddToJd = false"
      :isSingle="true"
      :from="'cvSearch'"
    />
    <AcceptReject
      v-if="openAcceptReject"
      :openAcceptReject="openAcceptReject"
      :decision="decision"
      :title="profile.fullName"
      :from="'candidate'"
      :jobID="$route.query.jobID"
      :candidateID="$route.query.candidateID"
      @close-accept-reject="closeAcceptReject"
    />
    <AddToJDSuccessSingle
      v-if="showCandTPModal"
      :showAddToJDSuccessSingle="showCandTPModal"
      :selectedjd="selectedjd"
      :candidateSelectedToThirdParty="populatedCustomFields"
      @hide-single-cand-jd-modal="showCandTPModal = false"
    />
  </div>
</template>

<script>
import AddtoJDModal from "@/controllers/Talentpool/AddtoJDModal.vue";
import AddToJDSuccessSingle from "@/controllers/Talentpool/AddToJDSuccessSingle.vue";
import AcceptReject from "@/controllers/OpsHeadApproval/Modal/AcceptReject.vue";
import {
  converterAtsPreview,
  getCandidateProfileInfo,
  getCandidateTestInfo,
  getResumeTemp,
  htmlToPDF,
  tetrisAPI,
  tempResume,
} from "@/utils/apiFunctions";
import cvSearch from "@/components/mixin/cvSearch";
import Spinner from "@/components/fixedcomponents/Spinner.vue";
import EventBus from "@/utils/eventBus";
import { mapGetters } from "vuex";

const GRAPHICAL = "graphical";
const ATS = "ats";
const VIDEO = "video";

export default {
  name: "ViewCandidateProfile",
  components: {
    AddtoJDModal,
    AddToJDSuccessSingle,
    AcceptReject,
    Spinner,
  },
  mixins: [cvSearch],
  data() {
    return {
      // STRINGS
      decision: "",
      hoveredCard: null,
      // BOOLEAN
      atsResumeLoader: false,
      isDownloading: false,
      openAcceptReject: false,
      isRotating: false,
      loaderStatus: false,
      showAddToJDSuccessSingle: false,
      isResumeExpanded: false,
      isATSTemplateLoaded: false,
      showAddToJobText: false,
      showAddToTalentPool: false,
      showExpandButton: false,
      showCandTPModal: false,
      showAddToJd: false,
      isTemplateLoaded: false,

      // OBJECTS
      atsPagination: {
        currentPage: 1,
        totalPages: null,
      },
      atsModalPagination: {
        currentPage: 1,
        totalPages: null,
      },
      showMore: {
        profileSummary: false,
        project: {
          responsibility: [],
        },
      },
      graphicalResume: {},
      atsResume: {},

      // ARRAYS
      selectedProfiles: [],
      tests: [],
      selectedjd: [],

      // NUMBERS
      profile: null,
      showResume: null,
    };
  },
  created() {
    this.getProfile();
    this.getTests();
  },
  watch: {
    showResume(curr, prev) {
      if (prev !== null && prev !== curr && curr === GRAPHICAL) {
        this.callScripts();
      }
    },
  },
  filters: {
    formatDate(data) {
      if (!data) return "-";
      let formattedDate = data.slice(0, 10).split("-").reverse().join("-");
      return formattedDate;
    },
    formatDateToCustomString(dateString) {
      const date = new Date(dateString);

      const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
      };

      return date.toLocaleDateString("en-US", options);
    },
  },
  methods: {
    avgStyle({ avg, max }) {
      const a = Number(avg);
      const m = Number(max);

      if (!isFinite(a) || !isFinite(m)) return {};

      if (m <= 0 || a <= 0) return { left: "0%" };

      // calculate position
      let percent = (a / m) * 100;

      // clamp between 0% and 100%
      percent = Math.max(0, Math.min(percent, 100));

      return {
        left: `${percent}%`,
        transform:
          percent > 90
            ? "translateX(-100%)" // pull left when near the right edge
            : "translateX(-50%)", // center normally
      };
    },

    // avgStyle({ avg, max }) {
    //   const a = Number(avg);
    //   const m = Number(max);

    //   if (!isFinite(a) || !isFinite(m)) return {};

    //   // case: no max
    //   if (m <= 0) return { left: "0px" };

    //   // case: avg <= 0
    //   if (a <= 0) return { left: "0px" };

    //   // case: avg >= max → stay inside bar
    //   if (a >= m) return { left: "calc(100% - 36px)" };

    //   // normal case
    //   return { left: `${(a / m) * 100}%` };
    // },
    scrollTop() {
      if (document.getElementById("scrollToTop") != null) {
        let element = document.getElementById("scrollToTop");
        element.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
    async tempResumePath(email, fileName, blobFile) {
      const fileWithName = new File([blobFile], fileName, {
        type: "application/pdf",
      });

      const formData = new FormData();
      formData.append("email", email);
      formData.append("fileName", fileName);
      formData.append("pdfFile", fileWithName);

      try {
        const response = await tempResume(formData);
        if (response.status === 200) {
          this.atsResumeLoader = false;
          console.log("Resume uploaded");
        } else {
          this.atsResumeLoader = false;

          console.error("Unexpected response:", response);
        }
      } catch (error) {
        this.atsResumeLoader = false;

        console.error("Error uploading resume:", error);
      }
    },
    closeAcceptReject() {
      this.openAcceptReject = false;
      EventBus.$emit("on-close-acceptreject");
    },
    toggleShowMoreForIndex(array, index) {
      if (!array[index]) this.$set(array, index, true);
      else this.$set(array, index, false);
    },
    toggleRotation() {
      this.isRotating = !this.isRotating;
    },
    async downloadResume() {
      this.isDownloading = true;
      this.showGraphicalResume
        ? await this.downloadGraphicalResume()
        : this.showATSResume
        ? await this.downloadATSResume()
        : null;
      this.isDownloading = false;
    },
    getHTMLFile(rawHTML = false) {
      let scriptContent = document.createElement("script");
      let converterContent = document.createElement("script");
      for (let i = 0; i < this.graphicalResume.rows.length; i++) {
        const curRow = this.graphicalResume.rows[i];
        for (let j = 0; j < this.graphicalResume.rowData[curRow].length; j++) {
          if (this.graphicalResume.rowData[curRow][j].script) {
            scriptContent.innerHTML +=
              this.graphicalResume.rowData[curRow][j].script;
            if (
              this.graphicalResume.rowData[curRow][j].converterCalls &&
              this.graphicalResume.rowData[curRow][j].content != "basicInfo"
            )
              converterContent.innerHTML +=
                this.graphicalResume.rowData[curRow][j].converterCalls;
          }
        }
      }
      for (let col of this.graphicalResume.columnData) {
        if (col.script && col.content !== "basicInfo") {
          scriptContent.innerHTML += col.script;
          converterContent.innerHTML += col.converterCalls;
        }
      }
      let element = document.getElementById("graph-resume");
      let html = document.createElement("html");

      let div = document.createElement("div");
      div.innerHTML = `${element.innerHTML}`;
      let expandBtns = div.querySelectorAll("[expand-resume-btn]");
      for (let element of expandBtns) {
        element.remove();
      }

      element = div;
      /* eslint no-useless-escape: 0 */
      html.innerHTML = `<head>
                    <style>
                    @media print {
                        #graph-resume {
                            margin: 0;
                            padding: 0;
                            box-shadow: 0;
                            position: absolute;
                            top: 0;
                            left: 0;
                        }
                        }
                    @font-face {
                    font-family: 'Inter';
                    font-style: normal;
                    font-weight: 400;
                    font-display: swap;
                    src: url(https://fonts.gstatic.com/s/inter/v13/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format('woff2');
                    unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
                    }
                    /* cyrillic */
                    @font-face {
                    font-family: 'Inter';
                    font-style: normal;
                    font-weight: 400;
                    font-display: swap;
                    src: url(https://fonts.gstatic.com/s/inter/v13/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format('woff2');
                    unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
                    }
                    /* greek-ext */
                    @font-face {
                    font-family: 'Inter';
                    font-style: normal;
                    font-weight: 400;
                    font-display: swap;
                    src: url(https://fonts.gstatic.com/s/inter/v13/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format('woff2');
                    unicode-range: U+1F00-1FFF;
                    }
                    /* greek */
                    @font-face {
                    font-family: 'Inter';
                    font-style: normal;
                    font-weight: 400;
                    font-display: swap;
                    src: url(https://fonts.gstatic.com/s/inter/v13/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format('woff2');
                    unicode-range: U+0370-03FF;
                    }
                    /* vietnamese */
                    @font-face {
                    font-family: 'Inter';
                    font-style: normal;
                    font-weight: 400;
                    font-display: swap;
                    src: url(https://fonts.gstatic.com/s/inter/v13/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format('woff2');
                    unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB;
                    }
                    /* latin-ext */
                    @font-face {
                    font-family: 'Inter';
                    font-style: normal;
                    font-weight: 400;
                    font-display: swap;
                    src: url(https://fonts.gstatic.com/s/inter/v13/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format('woff2');
                    unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
                    }
                    /* latin */
                    @font-face {
                    font-family: 'Inter';
                    font-style: normal;
                    font-weight: 400;
                    font-display: swap;
                    src: url(https://fonts.gstatic.com/s/inter/v13/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format('woff2');
                    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
                    }
                    /* cyrillic-ext */
                    @font-face {
                    font-family: 'Inter';
                    font-style: normal;
                    font-weight: 700;
                    font-display: swap;
                    src: url(https://fonts.gstatic.com/s/inter/v13/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2JL7SUc.woff2) format('woff2');
                    unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
                    }
                    /* cyrillic */
                    @font-face {
                    font-family: 'Inter';
                    font-style: normal;
                    font-weight: 700;
                    font-display: swap;
                    src: url(https://fonts.gstatic.com/s/inter/v13/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa0ZL7SUc.woff2) format('woff2');
                    unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
                    }
                    /* greek-ext */
                    @font-face {
                    font-family: 'Inter';
                    font-style: normal;
                    font-weight: 700;
                    font-display: swap;
                    src: url(https://fonts.gstatic.com/s/inter/v13/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2ZL7SUc.woff2) format('woff2');
                    unicode-range: U+1F00-1FFF;
                    }
                    /* greek */
                    @font-face {
                    font-family: 'Inter';
                    font-style: normal;
                    font-weight: 700;
                    font-display: swap;
                    src: url(https://fonts.gstatic.com/s/inter/v13/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1pL7SUc.woff2) format('woff2');
                    unicode-range: U+0370-03FF;
                    }
                    /* vietnamese */
                    @font-face {
                    font-family: 'Inter';
                    font-style: normal;
                    font-weight: 700;
                    font-display: swap;
                    src: url(https://fonts.gstatic.com/s/inter/v13/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa2pL7SUc.woff2) format('woff2');
                    unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB;
                    }
                    /* latin-ext */
                    @font-face {
                    font-family: 'Inter';
                    font-style: normal;
                    font-weight: 700;
                    font-display: swap;
                    src: url(https://fonts.gstatic.com/s/inter/v13/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa25L7SUc.woff2) format('woff2');
                    unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
                    }


                    /* latin */
                    @font-face {
                    font-family: 'Inter';
                    font-style: normal;
                    font-weight: 700;
                    font-display: swap;
                    src: url(https://fonts.gstatic.com/s/inter/v13/UcC73FwrK3iLTeHuS_fvQtMwCp50KnMa1ZL7.woff2) format('woff2');
                    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
                    }
                        .d-flex{
                            display: flex;
                        }
                        .w-100{
                            width: 100%;
                        }
                        .a4{
                            width: 21cm;
                            height: 29.7cm;
                            overflow: hidden;
                            background: white;
                            display: block;
                            margin: 0 auto;
                            margin-bottom: 0.5cm;
                            box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
                            position: relative;
                        }
                    </style>
                </head>
                <body>
                    ${element.innerHTML}
                    <script>
                    ${scriptContent.innerHTML}
                    ${converterContent.innerHTML}
                    <\/script>
                </body>`;

      let pageContent = `<html>${html.innerHTML}</html>`;
      if (rawHTML) {
        return `${element.innerHTML}`;
      } else {
        return new Blob([pageContent], {
          type: "text/html",
        });
      }
    },
    async downloadATSResume() {
      try {
        const blob = new Blob([this.atsResume.resumeData], {
          type: "text/html",
        });

        const formData = new FormData();
        formData.append("html_file", blob);
        formData.append("type", "recruitment");
        formData.append("outputPath", this.profile.profileName);
        formData.append(
          "uploadPath",
          this.profile.uploadPath + "/ATS/downloads/"
        );
        const res = await htmlToPDF(formData);
        if (res.status === 200) {
          let anchor = document.createElement("a");
          anchor.href = res.data.link;
          document.body.appendChild(anchor);
          anchor.click();
          document.body.removeChild(anchor);
        } else {
          this.errorModal("Error", "Something went wrong !");
        }
      } catch (error) {
        this.errorModal("Error", "Something went wrong !");
      }
    },
    async downloadGraphicalResume() {
      try {
        const blob = this.getHTMLFile();

        const formData = new FormData();
        formData.append("html_file", blob, "resume.html");
        formData.append("uploadPath", this.profile.uploadPath + "/downloads/");
        formData.append("type", "recruitment");
        formData.append("outputPath", this.profile.profileName);

        const res = await htmlToPDF(formData);
        if (res.status == 200) {
          let anchor = document.createElement("a");
          anchor.href = res.data.link;
          document.body.appendChild(anchor);
          anchor.click();
          document.body.removeChild(anchor);
        } else {
          this.errorModal("Error", "Something went wrong !");
        }
      } catch (error) {
        this.errorModal("Error", "Something went wrong !");
      }
    },
    scrollToResume() {
      this.showResume = this.videoResumeExists
        ? VIDEO
        : this.graphicalResumeExists
        ? GRAPHICAL
        : ATS;
      document.getElementById("resume-container").scrollIntoView({
        behavior: "smooth",
      });
    },
    async getATS() {
      window.pdfjsLib.GlobalWorkerOptions.workerSrc =
        "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.worker.min.js";

      const templateID = this.profile.atsResume.templateID || "template1";
      const fileName = `${this.profile._id}_${templateID}`;

      const resume = await getResumeTemp(templateID, this.profile._id);

      this.atsResume = {
        resumeData: resume.data,
        resumeDataUrls: [],
        resumeLink: null,
      };

      const blob = new Blob([this.atsResume.resumeData], {
        type: "text/html",
      });
      const formData = new FormData();
      formData.append("htmlFile", blob);
      formData.append("returnType", "pdf");
      formData.append(
        "outputPath",
        `${this.profile._id}_${this.profile.atsResume.templateID}`
      );
      formData.append("outputPath", fileName);
      const pdf = await converterAtsPreview(formData);

      const url = URL.createObjectURL(pdf.data);
      const loadingTask = window.pdfjsLib.getDocument({ url });
      const pdfDocument = await loadingTask.promise;
      const numPages = pdfDocument._pdfInfo.numPages;
      this.atsPagination.totalPages = numPages;
      this.atsModalPagination.totalPages = numPages;

      if (this.profile && this.profile.resumePath == null) {
        await this.tempResumePath(this.profile.email, fileName, pdf.data);
      }
      await this.renderAtsPdf(pdfDocument, numPages, url);
    },
    async renderAtsPdf(pdfDocument, numPages, link) {
      for (let pageNumber = 1; pageNumber <= numPages; pageNumber++) {
        const page = await pdfDocument.getPage(pageNumber);
        const scale = 3.0;
        const viewport = page.getViewport({ scale });
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.style.width = "450px";
        canvas.style.height = "580px";
        const canvasWidth = viewport.width;
        canvas.width = canvasWidth;
        const scaleFactor = canvasWidth / viewport.width;
        const canvasHeight = viewport.height * scaleFactor;
        canvas.height = canvasHeight;
        await page.render({ canvasContext: context, viewport: viewport })
          .promise;
        const imageDataUrl = canvas.toDataURL("image/png");
        this.atsResume.resumeDataUrls.push(imageDataUrl);
        this.atsResume.resumeLink = link;
      }
      this.isATSTemplateLoaded = true;
    },

    async getSvgs() {
      try {
        const headers = {
          userObj: this.profile._id,
        };
        const response = await tetrisAPI(
          this.profile.graphicalResume.templateID,
          headers
        );
        this.graphicalResume = response.data.data;
        if (this.graphicalResume.rows.length > 0) {
          for (const key of this.graphicalResume.rows) {
            this.graphicalResume.rowData[key].sort(
              (a, b) => a.position - b.position
            );
          }
        }
        if (this.graphicalResume.columnData.length > 0) {
          this.graphicalResume.columnData.sort(
            (a, b) => a.position - b.position
          );
        }
        this.isTemplateLoaded = true;
        return new Promise((res) => {
          setTimeout(() => {
            this.applyScript();
            this.callScripts();
            res();
          }, 500);
        });
      } catch (error) {
        console.error(error);
        this.isTemplateLoaded = false;
      }
    },
    applyScript() {
      const div = document.getElementById("resume-container");
      for (let i = 0; i < this.graphicalResume.rows.length; i++) {
        const curRow = this.graphicalResume.rows[i];
        for (let j = 0; j < this.graphicalResume.rowData[curRow].length; j++) {
          if (this.graphicalResume.rowData[curRow][j].script) {
            let script = document.createElement("script");
            script.innerHTML = this.graphicalResume.rowData[curRow][j].script;
            div.appendChild(script);
          }
        }
      }
      for (let col of this.graphicalResume.columnData) {
        if (col.script) {
          let script = document.createElement("script");
          script.innerHTML = col.script;
          div.appendChild(script);
        }
      }
      if (this.graphicalResume.sharedRow) {
        for (let col of this.graphicalResume.sharedRowData) {
          if (col.script) {
            let script = document.createElement("script");
            script.innerHTML = col.script;
            div.appendChild(script);
          }
        }
      }
    },
    callScripts() {
      const promises = [];
      for (let i = 0; i < this.graphicalResume.rows.length; i++) {
        const curRow = this.graphicalResume.rows[i];
        for (let j = 0; j < this.graphicalResume.rowData[curRow].length; j++) {
          if (this.graphicalResume.rowData[curRow][j].script) {
            promises.push(
              new Promise((res) => {
                setTimeout(() => {
                  eval(this.graphicalResume.rowData[curRow][j].calls);
                  res();
                }, 200);
              })
            );
          }
        }
      }
      for (let col of this.graphicalResume.columnData) {
        if (col.script) {
          promises.push(
            new Promise((res) => {
              setTimeout(() => {
                eval(col.calls);
                res();
              }, 200);
            })
          );
        }
      }
      if (this.graphicalResume.sharedRow) {
        for (let col of this.graphicalResume.sharedRowData) {
          if (col.script) {
            promises.push(
              new Promise((res) => {
                setTimeout(() => {
                  eval(col.calls);
                  res();
                }, 200);
              })
            );
          }
        }
      }
      return promises;
    },
    applyMargin(index) {
      if (index === 0) {
        if (this.graphicalResume.template_id === "graph_template_4") {
          return "height:50%;margin-top:0px;";
        } else {
          return "height:25%;margin-top:0px";
        }
      } else if (index == 2) {
        return "height:25%;margin-top:3px";
      } else {
        return "height:25%;margin-top:2px";
      }
    },
    applyStyle(index) {
      // if(selectedTemplate.template_id==='graph_template_2'){
      if (index === 0) {
        return "height:24.5%; margin-top:0px";
      } else if (index == 1) {
        return "height:25%; margin-top:6px";
      } else {
        return "height:25%; margin-top:3px";
      }
      // }
      // else
    },
    async getTests() {
      try {
        const res = await getCandidateTestInfo(this.$route.params.email);
        if (res.status === 200) {
          this.processTests(res.data.data);
        }
      } catch (error) {
        throw new Error(`Failed! Status:${error.status}`);
      }
    },
    processTests(tests) {
      this.tests = tests.map((test) => {
        // Add a color property for each summary item
        test.summary = test.summary.map((item) => ({
          ...item,
          colorClass:
            item.result === "Pass" ? "positive-circle" : "negative-circle",
        }));
        return test;
      });
    },
    conditionallySlice(array, slice, n) {
      return array.slice(0, slice ? n : array.length);
    },
    gobackpointer() {
      this.$router.go(-1);
    },
    openLink(link) {
      window.open(link, "_blank");
    },
    formatDate(inputDate) {
      if (!inputDate) return "NA";
      const date = new Date(inputDate);
      const formattedDate = date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
      });
      return formattedDate;
    },
    toTitleCase(string) {
      if (!string) return "";
      return string
        .split(" ")
        .map((w) => (w[0] ? w[0].toUpperCase() + w.slice(1) : w))
        .join(" ");
    },
    formatDOB(dob) {
      return new Date(dob).toLocaleDateString().replaceAll("/", "-");
    },
    arrayToString(arr) {
      arr = arr.filter((a) => a);
      return this.toTitleCase(arr.join(", "));
    },
    async getProfile() {
      try {
        this.loaderStatus = true;
        this.selectedProfiles = [];
        const res = await getCandidateProfileInfo(this.$route.params.email);
        if (res.status == 200) {
          this.profile = res.data.data;
          this.selectedProfiles = [this.profile];
          console.log("profile", this.profile);
          if (this.profile && this.profile.resumePath == null) {
            this.atsResumeLoader = true;
          }
        }
        // if (this.profile.graphicalResume.templateID) this.getSvgs();
        this.getATS();
        // if (this.graphicalResumeExists) this.showResume = GRAPHICAL;
        if (this.ATSResumeExists) this.showResume = ATS;
        else if (this.videoResumeExists) this.showResume = VIDEO;
      } catch (error) {
        this.loaderStatus = false;
        throw new Error(`Failed! Status:${error}`);
      }
      this.loaderStatus = false;
    },
  },
  computed: {
    showGraphicalResume() {
      return this.showResume === GRAPHICAL;
    },
    showATSResume() {
      return this.showResume === ATS;
    },
    showVideoResume() {
      return this.showResume === VIDEO;
    },
    ATSResumeExists() {
      return true;
    },
    graphicalResumeExists() {
      return this.profile.graphicalResume.templateID;
    },
    videoResumeExists() {
      return !!this.profile.videoResume;
    },
    certificates() {
      return this.profile.achievement.filter(
        (achievement) => achievement.achieveType == "certificate"
      );
    },
    //constants
    GRAPHICAL() {
      return GRAPHICAL;
    },
    ATS() {
      return ATS;
    },
    VIDEO() {
      return VIDEO;
    },
    ...mapGetters("cvSearchVUEX", {
      getJobIDs: "getJobIDs",
      whereFrom: "whereFrom",
    }),
    ...mapGetters(["roles"]),
  },
};
</script>

<style>
.testrankingbar {
  box-sizing: border-box;
  width: unset;
  height: 18px;
  background: #3f698e;
  border: 0.5px solid #c4c4c4;
  box-shadow: 0px 0px 5px rgb(86 86 86 / 20%);
  border-radius: 11px;
  margin: 15px;
}

.average-negative {
  width: 10px;
  height: 21px;
  border-radius: 11px;
  position: absolute;
  background: #ffffff;
}

.avg-marks {
  position: absolute;
  align-items: center;
  display: flex;
  top: -32px;
  white-space: nowrap;
}

.text-pos {
  position: relative;
  align-items: center;
  display: flex;
  top: 28px;
}

.cp-datetext {
  font-weight: 400;
  font-size: 12px;
  color: #6d6d6d;
}

.cp-asmnttext {
  font-weight: 600;
  font-size: 12px;
  color: #696969;
}

.positive-circle {
  width: 38px;
  height: 38px;
  border-radius: 20px;
  border: 4px solid white;
  background: rgba(3, 142, 0, 1);
  position: absolute;
}

.negative-circle {
  width: 38px;
  height: 38px;
  border-radius: 20px;
  border: 4px solid white;
  background: var(--cv-red);
  position: absolute;
}

.cp-asmnttext-new {
  font-weight: 600;
  font-size: 14px;
  color: rgba(255, 255, 255, 1);
}

.cv-font-size-13 {
  font-size: var(--size-13);
}

.viewcand-parent .popover-body {
  color: #565656;
  font-weight: 400;
  font-size: 10px !important;
  font-family: "montserrat", sans-serif;
  background-color: #d9d9d9;
  box-shadow: 0px 4px 4px 0px #00000014;
  border-radius: 8px;
}
</style>
